import configuration from '../../utils/configuration';

const getValidImageMimes = () => 
  configuration.get('configData.content_image_mime').split(',')
    .map((mime) => `.${mime}`)
    .join(',');

const getValidImageAndVideoMimes = () =>
  [
    ...configuration.get('configData.content_image_mime').split(','),
    ...configuration.get('configData.content_video_mime').split(','),
  ]
    .map((mime) => `.${mime}`)
    .join(',');

const getValidAdImageMimes = () => 
  configuration.get('configData.ad_image_asset_mime').split(',')
    .map((mime) => `.${mime}`)
    .join(',');

const getValidAdAssetMimes = () =>
  [
    ...configuration.get('configData.ad_image_asset_mime').split(','),
    ...configuration.get('configData.ad_video_asset_mime').split(','),
  ]
    .map((mime) => `.${mime}`)
    .join(',');


const getIntSetting = (key, defaultValue = null) => {
  try {
    return parseInt(configuration.get(key) || defaultValue)
  } catch (error) {
    console.error(`Unable to get int setting ${key}: ${error.stack}`)
    return defaultValue
  }
}

const getFloatSetting = (key, defaultValue = null) => {
  try {
    return parseFloat(configuration.get(key) || defaultValue)
  } catch (error) {
    console.error(`Unable to get float setting ${key}: ${error.stack}`)
    return defaultValue
  }
}

function getExtname(filename) {
  if (typeof filename !== 'string') return '';

  const lastSlash = Math.max(filename.lastIndexOf('/'), filename.lastIndexOf('\\'));
  const lastDot = filename.lastIndexOf('.');

  // No dot, or dot appears before the last slash → no extension
  if (lastDot <= lastSlash) return '';

  // Dot is the last character (e.g., "file.") → no extension
  if (lastDot === filename.length - 1) return '';

  return filename.slice(lastDot);
}

export {
  getExtname,
  getIntSetting,
  getFloatSetting,
  getValidImageMimes,
  getValidAdAssetMimes,
  getValidAdImageMimes,
  getValidImageAndVideoMimes
};
